import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: localStorage.getItem('status') || '',
        token: localStorage.getItem('token') || '',
        userName: localStorage.getItem('userName') || '',
        userID: localStorage.getItem('userID') || '',
        debugBarStatus: localStorage.getItem('debugBarStatus') || '',
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, { token, user, user_id, debugBarStatus }) {
            state.status = 'success'
            state.token = token
            state.userName = user
            state.userID = user_id
            state.debugBarStatus = debugBarStatus
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
            state.userName = ''
            state.userID = ''
            state.debugBarStatus = ''
        }
    },
    actions: {
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({ url: '/api/auth/login', data: user, method: 'POST' })
                    .then(response => {
                        const token = response.data.access_token
                        const user = response.data.user.name
                        const user_id = response.data.user.id
                        const debugBarStatus = response.data.user.exp
                        localStorage.setItem('token', token)
                        localStorage.setItem('status', 'success')
                        localStorage.setItem('userName', user)
                        localStorage.setItem('userID', user_id)
                        localStorage.setItem('debugBarStatus', debugBarStatus)
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
                        // !! LOOK here
                        commit('auth_success', { token, user, user_id, debugBarStatus })
                        resolve(response)
                    })
                    .catch(error => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        localStorage.removeItem('status')
                        localStorage.removeItem('userName')
                        localStorage.removeItem('userID')
                        localStorage.removeItem('debugBarStatus')
                        reject(error)
                    })
            })
        },
        logout({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/logout')
                    .then(response => {
                        localStorage.removeItem('token')
                        localStorage.removeItem('status')
                        localStorage.removeItem('userName')
                        localStorage.removeItem('userID')
                        localStorage.removeItem('debugBarStatus')
                        delete axios.defaults.headers.common['Authorization']
                        commit('logout')
                        resolve()
                    }).catch(error => {
                        console.log(error)
                        localStorage.removeItem('token')
                        localStorage.removeItem('status')
                        localStorage.removeItem('userName')
                        localStorage.removeItem('userID')
                        localStorage.removeItem('debugBarStatus')
                        delete axios.defaults.headers.common['Authorization']
                        commit('logout')
                        resolve()
                    })
            })
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        getUserName: state => state.userName,
        getUserID: state => state.userID,
        getPerms: state => state.debugBarStatus,
    }
})